var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.2,3.1C34.8,3.1,2.9,35,2.9,74.3s31.9,71.2,71.2,71.2,71.2-31.9,71.2-71.2S113.5,3.1,74.2,3.1ZM75,132.8c-32.3,0-58.5-26.2-58.5-58.5S42.7,15.8,75,15.8s58.5,26.2,58.5,58.5-26.2,58.5-58.5,58.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.7,
    y: 47.9,
    width: 23.4,
    height: 23.4,
    rx: 1.3,
    ry: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.5,
    y: 47.9,
    width: 23.4,
    height: 23.4,
    rx: 1.3,
    ry: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 92.3,
    y: 47.9,
    width: 23.4,
    height: 23.4,
    rx: 1.3,
    ry: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.7,
    y: 75.3,
    width: 23.4,
    height: 23.4,
    rx: 1.3,
    ry: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 64.5,
    y: 75.3,
    width: 23.4,
    height: 23.4,
    rx: 1.3,
    ry: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 92.3,
    y: 75.3,
    width: 23.4,
    height: 23.4,
    rx: 1.3,
    ry: 1.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridIcon);
export default __webpack_public_path__ + "static/media/grid_icon.92a3ad8d43e7cb18eb0171a6a1efea49.svg";
export { ForwardRef as ReactComponent };